import React, { useState } from "react";
import PropTypes from "prop-types";

import Modal from "../modal/Modal";

import { deleteAggregation } from "../../api/post-contract/PostContractPackageAPI";
import { AddEditPackageAggregation } from "./PackageAggregation.components";
import Spinner from "../common/Spinner";

PackageAggregationModal.propTypes = {
  projectId: PropTypes.string,
  packages: PropTypes.object,
};

export function PackageAggregationModal(props) {
  const { projectId, packages } = props;
  const [loading, setLoading] = useState(false);

  let aggregates = packages.data.filter((pack) => pack.IsAggregation === true);

  const display = [];

  aggregates.forEach((pack) => {
    let data = {
      packageId: pack.Id,
      packages: packages,
      projectId: projectId,
    };
    //Only display aggregates that are not project aggregation
    if (pack.IsProjectAggregation !== true) {
      display.push(
        <div className="aggregate-item">
          <div className="aggregate-name">{pack.PackageName}</div>

          <Button
            text={"Edit Aggregate Package"}
            Component={AddEditPackageAggregation}
            projectId={projectId}
            packages={packages}
            selectedPackage={pack}
            elementClass={"aggregate-edit-button"}
            icon={<i className="fas fa-edit"></i>}
            tooltip={"Edit"}
          />
          <DeleteButton
            data={data}
            loading={loading}
            setLoading={setLoading}
            onDelete={deleteAggregation}
          />
        </div>
      );
    }
  });

  return (
    <div className="pcf-container">
      <div className="general-row-container">
        <Button
          text={"Add Aggregate Package"}
          Component={AddEditPackageAggregation}
          projectId={projectId}
          packages={packages}
          selectedPackage={null}
          elementClass={"general-upload-button"}
          icon={"Create New"}
          tooltip={"Create New Aggregation"}
        />
      </div>
      <div className="aggregate-container">{display}</div>
    </div>
  );
}

Button.propTypes = {
  Component: PropTypes.object,
  tooltip: PropTypes.string,
  text: PropTypes.string,
  icon: PropTypes.object,
  elementClass: PropTypes.string,
};

function Button(props) {
  const { Component, tooltip } = props;
  const [modal, setModal] = useState(false);
  const { text, icon, elementClass } = props;

  return (
    <div>
      <button
        id="package-aggregation-button"
        className={elementClass}
        title={tooltip}
        onClick={() => {
          setModal(true);
        }}
      >
        {icon}
      </button>
      <Modal
        // Modal Props
        title={text}
        Component={Component}
        modal={modal}
        setModal={setModal}
        // Component Props
        show={modal}
        setShow={setModal}
        {...props}
      />
    </div>
  );
}

DeleteButton.propTypes = {
  loading: PropTypes.bool,
  setLoading: PropTypes.func,
  data: PropTypes.object,
  onDelete: PropTypes.func,
};

function DeleteButton(props) {
  const { loading, setLoading } = props;
  const { data, onDelete } = props;

  if (loading) {
    return <Spinner width={40}></Spinner>;
  } else {
    return (
      <button
        id="delete-aggregate-button"
        className="clarification-delete-button"
        title="Delete"
        onClick={async () => {
          setLoading(true);
          if (await onDelete(data)) {
            setLoading(false);
          }
        }}
      >
        <i className="far fa-trash-alt"></i>
      </button>
    );
  }
}
